const DEFAULT_DELAY_MS = process.env.NODE_ENV === 'test' ? 0 : 2000;

/**
 * Runs a request, and if it rejects runs it once more after a short pause.
 * Covers a transient failure (a 5xx, a dropped connection) without leaving a
 * gadget in its error state. A second rejection is passed on.
 */
const retryOnce = async <T>({
  run,
  delayMs = DEFAULT_DELAY_MS,
}: {
  run: () => Promise<T>;
  delayMs?: number;
}): Promise<T> => {
  try {
    return await run();
  } catch (error) {
    console.warn('Request failed, retrying once', error);
    if (delayMs > 0) {
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
    return run();
  }
};

export default retryOnce;
